import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { updateUser } from '../index';
export const useUpdateUser = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(updateUser, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetUsers');
            setAction({
                type: 'success',
                message: 'Updating the user was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
